export default __webpack_public_path__ + "static/media/RakshabandanNew4.eb0bd16e.png";